import { render, staticRenderFns } from "./PNotifications.vue?vue&type=template&id=d00054f4"
import script from "./PNotifications.vue?vue&type=script&lang=js"
export * from "./PNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports